import React, { useEffect, useState } from "react";
import "./index.css";
import Cookies from "universal-cookie";

const ContactsSummery = ({ contacts }) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  console.log("contacts", contacts);

  return (
    <>
      <div className="summerycls">
        {contacts.map((d) => (
          <>
            {console.log("object", d)}
            <div key={d.key}>
              <div style={{ padding: "12px 12px 12px 12px" }}>
                <div className={`sumcontent ${d?.contactrole === "Primary Contact" ? "bold-text" : ""}`}>
                  Name: {d.entityid || "N/A"}
                </div>
                {/* <div className="sumhead">Name: {d.entityid}</div> */}
                <div className={`sumcontent ${d?.contactrole === "Primary Contact" ? "bold-text" : ""}`}>
                  Phone Number : {d.phone || "N/A"}
                </div>
                <div className={`sumcontent ${d?.contactrole === "Primary Contact" ? "bold-text" : ""}`}>
                  Email : {d.email || "N/A"}
                </div>
                <div className={`sumcontent ${d?.contactrole === "Primary Contact" ? "bold-text" : ""}`}>
                  Job Title : {d.jobtitle || "N/A"}
                </div>
              </div>
              <hr style={{ margin: "0rem" }} />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ContactsSummery;
